import currentTimeZone from '../enum/timeZone';

/**
 * Function to convert UTC time to date in the system's local time zone
 * and return it in YYYY-MM-DD format
 * @param {any} utcString - The UTC string to convert
 * @returns {any} - Formatted date (YYYY-MM-DD)
 */
function ConvertDDMMYYYYtoISO(utcString: string, time?: boolean): string {
  if (!utcString) {
    return '';
  }

  const date = new Date(utcString);

  // Convert to local time based on timezone
  const localDate = new Date(date.toLocaleString('en-SA', { timeZone: currentTimeZone }));

  const year = localDate.getFullYear();
  const month = String(localDate.getMonth() + 1).padStart(2, '0');
  const day = String(localDate.getDate()).padStart(2, '0');

  const hours = String(localDate.getHours()).padStart(2, '0');
  const minutes = String(localDate.getMinutes()).padStart(2, '0');
  const seconds = String(localDate.getSeconds()).padStart(2, '0');

  return time ? `${year}-${month}-${day} ${hours}:${minutes}:${seconds}` : `${year}-${month}-${day}`;
}

export default ConvertDDMMYYYYtoISO;
